import { Accordion } from '@moonpig/launchpad-components'
import React, { FC, useState } from 'react'
import { trackGAEvent } from '@moonpig/web-core-analytics'
import {
  AccordionSections,
  ProductDescriptionModule,
  DeliveryDetailsModule,
  ReviewsModule,
} from '../AccordionSections'
import { ProductAccordionSectionClickGAEvent } from '../analytics'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'
import { AccordionSectionActions } from '../AccordionSections/types'

const trackSectionClick = ({
  updatedSections,
  currentSections,
  productId,
}: {
  updatedSections: AccordionSections[]
  currentSections: AccordionSections[]
  productId: string
}) => {
  if (updatedSections.length > currentSections.length) {
    const openSection = updatedSections.filter(
      section => !currentSections.includes(section),
    )
    trackGAEvent(
      ProductAccordionSectionClickGAEvent(
        openSection[0],
        AccordionSectionActions.OPEN,
        productId,
      ),
    )
  } else {
    const closedSection = currentSections.filter(
      section => !updatedSections.includes(section),
    )
    trackGAEvent(
      ProductAccordionSectionClickGAEvent(
        closedSection[0],
        AccordionSectionActions.CLOSE,
        productId,
      ),
    )
  }
}

export const ThingsToKnowModule: FC<ProductModule> = props => {
  const [openSections, setOpenSections] = useState([
    AccordionSections.Description,
  ])

  const [
    {
      product: { id },
    },
  ] = useProductContext()

  return (
    <ProductModuleSection {...props}>
      <Accordion
        type="multiple"
        defaultValue={[AccordionSections.Description]}
        onValueChange={(updatedSections: AccordionSections[]) => {
          trackSectionClick({
            updatedSections,
            currentSections: openSections,
            productId: id,
          })

          setOpenSections(updatedSections)
        }}
      >
        <ProductDescriptionModule />
        <DeliveryDetailsModule />
        <ReviewsModule />
      </Accordion>
    </ProductModuleSection>
  )
}
